import React from 'react'
import HomePage from './header_glow/glow.component';
import Navbar1 from './navbar/Navbar';
import HomeFirstSlider from './mainSlider/Slider.component';
import Slides from './mainSlider/slides/slides.component';
import Courses from './courses/courses.component'
import Featurs from './features/featurs.component'
import Student from "./studentreview-partners/student.com"
import Footer from './footer/footer.component';
import { HomeBanner } from './home-banner/home-banner.component';
import './home.component.css';
import '../../js/scroll-animation.js';
import { About } from './about/about.component';
import { Header } from './header/header.component';
import { YoutubeLinks } from './youtube-links/youtube-links.component';
import { WhyUs } from './whyus/why-us.component';

function Home() {
  return (
    <div>
      <div className='c-header-top'>
			<HomeBanner></HomeBanner>

			<About></About>

			<Courses></Courses>
			
			<YoutubeLinks></YoutubeLinks>

			<WhyUs></WhyUs>
		</div> 
    </div>
  )
}

export default Home;
